import styled from "styled-components";
import { device } from "../../styles/devices";

export const DataContainer = styled.div`
    color: var(--color-text);

    @media ${device.tablet}{
        order: 1;
        grid-column: 1/3;
        margin-top: 2rem;
    }
    h1{
        font-size: 3rem;
        line-height: 3.5rem;
        color: var(--color-title);
        margin-bottom: 0.5rem;

        @media ${device.tabletLarge}{
            font-size: 2.5rem;
            line-height: 3rem;
        }

        @media ${device.tablet}{
            font-size: 2rem;
            line-height: 2.5rem;
        }
        

        img{
            width: 32px;
            height: 32px;
            margin-left: 0.5rem;
            animation: hand_animation 1s ease-in-out infinite 1s;

            @media ${device.tabletLarge}{
                width: 24px;
                height: 24px;
            }
        }
    }

    h2{
        font-size: 1.3rem;
        line-height: 1.8rem;
        padding-left: 5.5rem;

        position: relative;
        margin-bottom: 1rem;

        @media ${device.tabletLarge}{
            padding-left: 2.5rem;
            font-size: 1.2rem;
            line-height: 1.7rem;
        }

        @media ${device.tablet}{
            font-size: 1rem;
            line-height: 1.5rem;
            padding-left: 2rem;
        }

        &::before{
            content: '';
            position: absolute;
            width: 70px;
            height: 1px;
            background-color: var(--color-text);
            left: 0;
            top: 1rem;

            @media ${device.tabletLarge}{
                width: 30px;
                top: .8rem;
            }

            @media ${device.tablet}{
                width: 20px;
                top: .7rem;
            }
            
        }
    }

    p{
        max-width: 400px;
        font-size: 1rem;
        font-weight: var(--font-normal);
        margin-bottom: 1.5rem;

        @media ${device.tablet}{
            max-width: initial;
        }
    }

    a{
        padding: 1rem 2rem;
        border-radius: var(--button-radius);
        background-color: var(--color-black);
        color: var(--color-white);
        font-weight: var(--font-medium);
        font-size: 1rem;
        display: inline-block;
        transition: .2s ease-in;
        box-shadow: 0 1px 8px rgba(0,0,0,0.15);

        &:hover{
            background-color: var(--color-black-hover);
        }

        i {
            font-size: 1.1rem;
            margin-left: .5rem;
            display: inline-block;
            transform: rotate(-45deg);
        }
    }

    @keyframes hand_animation {
        0%{
            transform: rotate(0deg);
        }
        50%{
            transform: rotate(30deg);
        }
        50%{
            transform: rotate(-30deg);
        }
    }

`;